<template>
  <PageLoading :is-loading="isLoading"></PageLoading>
  <SideComponent @scrollto="scroll"></SideComponent>
  <div class="container" ref="viewBox">
    <div class="header-container">
      <Header2 />
    </div>
    <div id="content" class="content" ref="content">
      <Loading :is-loading="isListLoading"></Loading>
      <section v-if="taleDetail.title" class="section">
        <div class="ar-content">
          <div style="font-family: 黑体, SimHei; font-size: 24px;font-weight:bold;">{{ taleDetail.title }}</div>
          <div
            class="html-content"
            style="margin-top: 20px;"
            id="html-content"
            v-html="taleDetail.content"
          ></div>
        </div>
      </section>
    </div>
    <Footer />
  </div>
</template>

<script>
import shanhai_qingdao_detail from './shanhai_qingdao_detail_controller';
export default shanhai_qingdao_detail;
</script>

<style src="@/assets/css/publish_detail.css" scoped></style>
